import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DateUtils from '../../DateUtils';

class Export<T> {
  public exportInXlsx = async (
    columns: string[],
    rows: T[],
    finishCallback: () => void,
  ): Promise<void> => {
    const exportName = `Export_${DateUtils.formatDateIntoInternational(`${Date.now()}`)}`;

    const workBook = XLSX.utils.book_new();
    workBook.Props = {
      Title: exportName,
      CreatedDate: new Date(Date.now()),
    };

    const sheetData = this.rowsToArraysOfArrays(columns, rows);
    sheetData.unshift(columns);
    const workSheet = XLSX.utils.aoa_to_sheet(sheetData);

    workBook.SheetNames.push(exportName);
    workBook.Sheets[exportName] = workSheet;
    const workBookBytes = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(workBookBytes, `${exportName}.xlsx`);

    finishCallback();
  };

  private rowsToArraysOfArrays = (columns: string[], rows: T[]): string[][] => {
    const arrayOfArrays: string[][] = [];

    rows.forEach((row: T) => {
      const rowArray: string[] = [];

      columns.forEach((column: string) => {
        rowArray.push(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          row[column],
        );
      });

      arrayOfArrays.push(rowArray);
    });

    return arrayOfArrays;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private saveAsExcelFile = (buffer: any, fileName: string): void => {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  };
}

export default Export;
